import React, { useMemo } from 'react';
import { MdDeleteSweep } from 'react-icons/md';
import { COLORS } from '@ydistri/theme';
import { InfoIconTooltip } from '../../icons/InfoIconTooltip';

export const DATA_DELETED_LIST_TOOLTIP = 'The data of this list were deleted.';
export const DATA_DELETED_VERSION_TOOLTIP = 'The data of this version were deleted.';

export type DataDeletedOf = 'list' | 'version';

interface DataDeletedEntityListIconProps {
  of?: DataDeletedOf;
  size?: number;
}

/**
 * Shown for a list or a list version whose data were deleted; for a list it replaces the archived icon,
 * because such a list is always archived.
 */
const DataDeletedEntityListIcon: React.FC<DataDeletedEntityListIconProps> = ({
  of = 'list',
  size = 16,
}) => {
  const icon = useMemo(
    () => <MdDeleteSweep size={size} color={COLORS.GREY} aria-hidden="true" />,
    [size],
  );

  return (
    <InfoIconTooltip
      icon={icon}
      content={of === 'version' ? DATA_DELETED_VERSION_TOOLTIP : DATA_DELETED_LIST_TOOLTIP}
    />
  );
};

export default DataDeletedEntityListIcon;
